import React from 'react'

class Page extends React.Component {
  render() {
    return (
      <div className='pageClass'>
        {this.props.children}
      </div>
    )
  }
}

export default Page
